import React from 'react';
import { FaPhone, FaWhatsapp, FaMapMarkerAlt, FaFacebookF, FaInstagram, FaYoutube, FaGoogle, FaArrowLeft } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';
import './Links.css';

const Links = () => {
  return (
    <div className="links-page">
      <div className="links-container">
        <Link to="/" className="back-button">
          <FaArrowLeft className="back-icon" />
          Back
        </Link>
        <div className="logo-section">
          <img src={logo} alt="Celebrity Cuts Logo" className="links-logo" />
          <p className="links-quote">Where Style Meets Elegance</p>
        </div>
        <div className="icons-section">
          <a href="tel:7730858858" className="icon-link" aria-label="Phone">
            <FaPhone className="icon" />
          </a>
          <a href="https://wa.me/7730858858" target="_blank" rel="noopener noreferrer" className="icon-link" aria-label="WhatsApp">
            <FaWhatsapp className="icon" />
          </a>
          <a href="https://www.google.com/maps/place/Celebrity+Cuts%7C+best+salon+in+madhurawada%7C+unisex+salon+in+vizag%7C+beauty+salon/@17.8026181,83.360767,831m/data=!3m2!1e3!4b1!4m6!3m5!1s0x3a395bd953cc2675:0x527e93e27abf7261!8m2!3d17.8026181!4d83.3633419!16s%2Fg%2F11jzqb0qfv?entry=ttu&g_ep=EgoyMDI1MTAxNC4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener noreferrer" className="icon-link" aria-label="Location">
            <FaMapMarkerAlt className="icon" />
          </a>
          <a href="https://www.facebook.com/stories/109239468661981/UzpfSVNDOjI1MjkyMzE1MDc0NDY4NTk=/?view_single=false" target="_blank" rel="noopener noreferrer" className="icon-link" aria-label="Facebook">
            <FaFacebookF className="icon" />
          </a>
          <a href="https://www.instagram.com/reel/DNITcB3yJEX/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" target="_blank" rel="noopener noreferrer" className="icon-link" aria-label="Instagram">
            <FaInstagram className="icon" />
          </a>
          <a href="https://www.youtube.com/@CelebrityCutsinvizag" target="_blank" rel="noopener noreferrer" className="icon-link" aria-label="YouTube">
            <FaYoutube className="icon" />
          </a>
          <a href="https://www.google.com/search?q=celebrity+cuts&rlz=1C1CHBD_en-GBIN1170IN1170&oq=celebrity+cuts+&gs_lcrp=EgZjaHJvbWUyBggAEEUYOTIGCAEQIxgnMg0IAhAuGK8BGMcBGIAEMgcIAxAAGIAEMgcIBBAAGIAEMgcIBBAAGIAEMgYIBRBFGDwyBggGEEUYPDIGCAcQRRg80gEINDA5NWowajeoAgCwAgA&sourceid=chrome&ie=UTF-8&zx=1761030692475&no_sw_cr=1" target="_blank" rel="noopener noreferrer" className="icon-link" aria-label="Google Business">
            <FaGoogle className="icon" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Links;
